import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import ResourcesList from '../components/ResourcesList';
import { schema } from '../../../../../state/schema';
import {
  loadResources,
  generateResourcesPDF,
} from '../../../../../state/modules/resources/actions';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  const profileId = state.session.get('profileId');
  const careGuideId = ownProps.careGuideId;

  const careGuide = careGuideId
    ? denormalize(
        state.entities.getIn(['careGuides', careGuideId]),
        schema.careGuide,
        state.entities.toJS()
      )
    : null;

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.resources.getIn([
    'results',
    careGuideId,
    'pages',
    order,
    limit,
    page,
  ]);

  return {
    careGuide,
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['resources', x]),
                schema.resource,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
      : [],
    total: state.resources.getIn(['results', careGuideId, 'total']),
    isLoading: state.resources.get('isLoading'),
    profileId: profileId,
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    isDownload:
      state.resourcesAdmin.get('isCSVDownloading') ||
      state.resourcesAdmin.get('isPDFDownloading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (careGuideId, page, limit, order, filter, cb) => {
      dispatch(loadResources(careGuideId, page, limit, order, filter, cb));
    },
    generatePDF: (careGuideId, page, limit, order, filter, cb) => {
      dispatch(
        generateResourcesPDF(careGuideId, page, limit, order, filter, cb)
      );
    },
  };
};

const ResourcesListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourcesList);

export default ResourcesListContainer;
